

export default class InfoControl {

  constructor(info) {
    this.info= info;
  }

  onAdd(map) {
    this._map = map;
    this._container = document.createElement('div');
    this._container.className = 'mapboxgl-custom-ctrl mapboxgl-ctrl';


    this._container.append(this.info);
    return this._container;
  }

  onRemove() {
    this._container.parentNode.removeChild(this._container);
    this._map = undefined;
  }



}
